import { useEffect, useRef, useState } from 'react';

const steps = [
  { n: '01', t: 'Book your visit', d: 'Request a time online or by phone. We confirm within one business day.', icon: 'ri-calendar-check-line' },
  { n: '02', t: 'Meet your care team', d: 'A quiet exam room, unhurried time, and a clinician who listens.', icon: 'ri-hand-heart-line' },
  { n: '03', t: 'Leave with a clear plan', d: 'Findings explained in plain language, with a written plan to take home.', icon: 'ri-file-list-3-line' },
];

export default function YourVisit() {
  const gridRef = useRef<HTMLDivElement | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = gridRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            io.disconnect();
          }
        });
      },
      { threshold: 0.2 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-container mx-auto px-5 md:px-12">
        <div className="max-w-text">
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">Your Visit</div>
          <h2 className="mt-3 font-display font-bold text-[44px] md:text-[58px] leading-[1.02] text-cocoa">
            What to expect, from the moment you book.
          </h2>
        </div>

        <div ref={gridRef} className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((s, i) => (
            <div
              key={s.n}
              className={`yv-card yv-d${i + 1} ${inView ? 'is-in' : ''} relative rounded-[32px] border border-line bg-warm p-8 md:p-10`}
            >
              <div className="flex items-center justify-between">
                <span className="yv-num font-display font-bold text-[56px] md:text-[68px] leading-none text-cocoa">{s.n}</span>
                <span className="yv-icon w-14 h-14 rounded-full bg-yellow flex items-center justify-center text-cocoa">
                  <i className={`${s.icon} text-[24px]`}></i>
                </span>
              </div>
              <h3 className="mt-8 font-display font-semibold text-[24px] md:text-[26px] text-cocoa">{s.t}</h3>
              <p className="mt-3 text-[15px] text-ink/75 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}